import { render, staticRenderFns } from "./locataire-seuil-di-alert.vue?vue&type=template&id=3170da93"
import script from "./locataire-seuil-di-alert.vue?vue&type=script&lang=ts"
export * from "./locataire-seuil-di-alert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports